



























import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component,  Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { validationData } from "@/entities";

@Component
export default class TopNavigationComponent extends Vue {
    @Prop() schema!: any;
    @Prop() selectedKey!: string;
    @Prop({default:""}) prevTopmenu: string;
    @Prop({default:0}) errCount: boolean;
    /** menu click event */
    menu_click(key){
        this.$emit('click', key);
    }
    showValidation()
    {
      this.$emit("showdialog",{})
    }
}
